import React, { useState, useRef, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
    TextField,
    Box,
    ToggleButtonGroup,
    ToggleButton,
    Tooltip,
} from '@mui/material';
import RequestService from '../../services/RequestService';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';

const CoinDialog = ({ open, onClose, user, onSuccess }) => {
    const [error, setError] = useState(null);
    const [isAdding, setIsAdding] = useState(true);
    const [formData, setFormData] = useState({
        coinAmount: 0,
        description: '',
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => {
            const updatedForm = {
                ...prev,
                [name]: type === 'checkbox' ? checked : value,
            };
            return updatedForm;
        });
    };

    const handleSubmit = async () => {
        try {
            const amount = Number(formData.coinAmount);
            if (!Number.isFinite(amount) || amount <= 0) {
                setError('Informe uma quantidade positiva de moedas.');
                return;
            }

            const payload = {
                ...formData,
                ...formData,
                userId: user.id,
                coinAmount: amount,
            };

            await RequestService.addCoinPlayer(isAdding, payload);
            onSuccess();
            onClose();
        } catch (err) {
            setError('Erro ao executar a operação. Verifique os dados.');
        }
    };

    const handleChangeOperation = (_event, newValue) => {
        if (newValue !== null) setIsAdding(newValue);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle
                sx={{
                    fontFamily: 'Poppins',
                    fontSize: '16px',
                    color: '#0C3466',
                    fontWeight: '600',
                }}
            >
                Gerenciar moedas
            </DialogTitle>
            <DialogContent>
                {user && (
                    <>
                        <Stack
                            direction="row"
                            spacing={1}
                            alignItems="center"
                            sx={{ mb: 1 }}
                        >
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                Qual operação você deseja executar?
                            </Typography>
                            <Tooltip title="As operações abaixo irão, respectivamente, adicionar ou remover moedas ao jogador selecionado.">
                                <HelpOutlineIcon
                                    color="primary"
                                    sx={{
                                        width: '18px',
                                        height: '18px',
                                    }}
                                />
                            </Tooltip>
                        </Stack>
                        <ToggleButtonGroup
                            value={isAdding}
                            exclusive
                            fullWidth
                            onChange={handleChangeOperation}
                            size="small"
                            sx={{ mb: 2 }}
                        >
                            <ToggleButton value={true}>Dar moedas</ToggleButton>
                            <ToggleButton value={false}>
                                Retirar moedas
                            </ToggleButton>
                        </ToggleButtonGroup>
                        <Box
                            sx={{
                                backgroundColor: '#EDF8FF',
                                borderRadius: '8px',
                                padding: '8px 12px',
                                marginBottom: '16px',
                            }}
                        >
                            <Stack direction="row" alignItems="center" gap={1}>
                                <CoinIcon />
                                <TextField
                                    label="Quantidade (moedas)"
                                    name="coinAmount"
                                    type="number"
                                    inputProps={{ min: 1, step: 1 }}
                                    value={formData.coinAmount}
                                    onChange={handleChange}
                                    fullWidth
                                />
                            </Stack>
                        </Box>
                    </>
                )}
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ mb: 2 }}
                >
                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                        Qual é o motivo dessa operação?
                    </Typography>
                    <Tooltip title="O jogador será notificado da operação com o motivo descrito abaixo.">
                        <HelpOutlineIcon
                            color="primary"
                            sx={{
                                width: '18px',
                                height: '18px',
                            }}
                        />
                    </Tooltip>
                </Stack>
                <TextField
                    label="Descrição"
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    fullWidth
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    onClick={onClose}
                    sx={{ width: '100%' }}
                >
                    Fechar
                </Button>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{ width: '100%' }}
                >
                    {isAdding ? 'Dar moedas' : 'Retirar moedas'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CoinDialog;
